// https://github.com/angular/components/blob/master/src/cdk/platform/platform.ts

import { Inject, Injectable, PLATFORM_ID } from '@angular/core';
import { isPlatformBrowser } from '@angular/common';

let hasV8BreakIterator: boolean;

try {
  hasV8BreakIterator =
    typeof Intl !== 'undefined' && (Intl as any).v8BreakIterator;
} catch {
  hasV8BreakIterator = false;
}

// eslint-disable-next-line complexity
@Injectable({ providedIn: 'root' })
export class PlatformService {
  isBrowser: boolean = this._platformId
    ? isPlatformBrowser(this._platformId)
    : typeof document === 'object' && !!document;
  EDGE: boolean = this.isBrowser && /(edge)/i.test(navigator.userAgent);
  TRIDENT: boolean =
    this.isBrowser && /(msie|trident)/i.test(navigator.userAgent);
  BLINK: boolean =
    this.isBrowser &&
    !!((window as any).chrome || hasV8BreakIterator) &&
    typeof CSS !== 'undefined' &&
    !this.EDGE &&
    !this.TRIDENT;
  WEBKIT: boolean =
    this.isBrowser &&
    /AppleWebKit/i.test(navigator.userAgent) &&
    !this.BLINK &&
    !this.EDGE &&
    !this.TRIDENT;
  IOS: boolean =
    this.isBrowser &&
    /iPad|iPhone|iPod/.test(navigator.userAgent) &&
    !('MSStream' in window);
  FIREFOX: boolean =
    this.isBrowser && /(firefox|minefield)/i.test(navigator.userAgent);
  ANDROID: boolean =
    this.isBrowser && /android/i.test(navigator.userAgent) && !this.TRIDENT;
  SAFARI: boolean =
    this.isBrowser && /safari/i.test(navigator.userAgent) && this.WEBKIT;

  // eslint-disable-next-line @typescript-eslint/ban-types
  constructor(@Inject(PLATFORM_ID) private _platformId: Object) {}
}
